/*
  Created by:Sundar Natarajan
  Created on: 26-July-19 2:15 PM
  Purpose: User Login Service Page
*/

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { jsonToQueryString } from 'src/app/controls/functions/shared-functions';
import { SessionService } from 'src/app/services/session/session.service';
@Injectable({
  providedIn: 'root'
})
export class LoginService {
  refresh_token_flag = 0;
  // api_url = environment.SERVER_URL + "Referral/";
  login_url = environment.SERVER_URL + 'icr/';
  current_ip
  constructor(
    private http: HttpClient,
    private session_svc: SessionService,
    private router: Router,
    private session: SessionService,
  ) {
  }

  generateAccessToken(params) {
    return this.http.post(this.login_url + 'weblogin', params).pipe(
      map(
        (res) => {
          if (res && res['data'] && res['status']) {
            // res['data'].isEmployer = params.isEmployer;
            if (res['data'].userDetails) {
              this.session_svc.setSession(res['data'].userDetails);
              this.session_svc.setUserDetails(res['data'].userDetails);
            }
            return res;
          } else {
            return res;
          }
        },
        (err) => {
          return err;
        }
      )
    );
  }

  getUserDetails() {
    return this.http.get(this.login_url + 'userdetail').pipe(
      map((res) => {
        if (res && res['data'] && res['data'].userData) {
          this.session_svc.setUserDetails(res['data'].userData);
          return res;
        }
      })
    );
  }
  getTwoStepAuth(params) {
    params.username = params.username;
    params.password = params.password;
    params['Primary-Role'] = 'recruiter';
    let query_string = jsonToQueryString(params);
    return this.http.post(this.login_url + "login/twoFactorAuthentication", query_string, { headers: { "Content-Type": "application/x-www-form-urlencoded" } })
      .pipe(
        map(res => {
          // this.session_svc.setSession(res);
          return res;
        }, err => {
          return err;
        })
      );
  }
  generateNewAccessToken() {
    if (!this.refresh_token_flag || 1) {
      this.refresh_token_flag = 1;
      let params = this.session_svc.user;
      params['username'] = params['userName'] || 'tester';
      params['password'] = params['password'] || 'testing';
      params['grant_type'] = 'refresh_token';
      params['refresh_token'] = params['refresh_token'];
      params['Primary-Role'] = 'recruiter';
      params['client_id'] = 't@ll!nt';
      params['client_secret'] = 't@ll!nt';
      let query_string = jsonToQueryString(params);
      this.http
        .post(this.login_url + 'token', query_string, {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        })
        .subscribe(
          (res) => {
            this.session_svc.setSession(res);
            this.refresh_token_flag = 0;
          },
          (err) => {
            this.router.navigate(['/login']);
          }
        );
    }
  }

  generateNewAccessToken1() {
    return new Observable((obs) => {
      if (!this.refresh_token_flag || 1) {
        this.refresh_token_flag = 1;
        let params = this.session_svc.user;
        params['username'] = params['userName'] || 'tester';
        params['password'] = params['password'] || 'testing';
        params['grant_type'] = 'refresh_token';
        params['refresh_token'] = params['refresh_token'];
        params['Primary-Role'] = 'recruiter';
        params['client_id'] = 't@ll!nt';
        params['client_secret'] = 't@ll!nt';
        let query_string = jsonToQueryString(params);
        this.http
          .post(this.login_url + 'token', query_string, {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          })
          .subscribe(
            (res) => {
              obs.next(true);
              this.session_svc.setSession(res);
              this.refresh_token_flag = 0;
            },
            (err) => {
              obs.next(false);
              this.router.navigate(['/login']);
            }
          );
      }
    });
  }

  forgotPassword(req) {
    //method for sending email via user ID
    return this.http.post(this.login_url + 'forgot_password_send_otp', req);
  }

  getMasters(ip?) {
    console.log(this.login_url)
    return this.http.post(this.login_url + 'master', {
      ip: ip,
    });
  }

  socialParams(sid, code, state) {
    return this.http.post(this.login_url + 'params', {
      sid: sid,
      code: code,
      state: state,
    });
  }

  verifyOTP(obj) {
    return this.http.post(this.login_url + 'verifyOtp', obj)
  }
  changeForgotPassword(obj) {
    return this.http.post(this.login_url + 'set_new_password', obj);
  }

  getAllLabels(file_path) {
    return this.http.get('assets/i18/' + file_path + '.json');
  }
  resendOTP(params) {
    params.username = params.username;
    params.password = params.password;
    params['Primary-Role'] = 'recruiter';
    let query_string = jsonToQueryString(params);
    return this.http.post(this.login_url + "login/reSendtwoFactorAuthentication", query_string, { headers: { "Content-Type": "application/x-www-form-urlencoded" } })
      .pipe(
        map(res => {
          // this.session_svc.setSession(res);
          return res;
        }, err => {
          return err;
        })
      );
  }


  resetPassSendOtp(obj) {
    return this.http.post(environment.SERVER_URL + "icr/pwdResetOtpWeb", obj);
  }

  resetPassVerifyOtp(obj) {
    return this.http.post(environment.SERVER_URL + "icr/verifyOtpWeb", obj);
  }

  newPassChange(obj) {
    return this.http.post(environment.SERVER_URL + 'icr/resetPassword', obj);
  }

  sendOTP(obj) {
    return this.http.post(environment.SERVER_URL + 'icr/sendOtpWeb', obj);
  }
  payJobpostingCost(obj) {
    return this.http.post(environment.SERVER_URL + 'icrweb/home/generateOrderForInvoice', obj);
  }
  firstLogin(params?) {
    let obj = {
      sellerShortCode: environment.SHORTCODE
    }
    return this.http.post(environment.SERVER_URL + 'icrweb/home/get_myjourney_status_check', obj, {
      params: params
    }).pipe(map(res => {

      if (res && res['status'] && res['data'].myJourney) {
        this.session.setMyJourneyDetails(res['data']);
      }
      return res;
    }));
  }
  checkLogin(request) {
    return this.http.post(environment.SERVER_URL + 'icr/login_check', request)
  }
}
